import styled from "styled-components";

function Pagination({ total, limit, page, setPage }) {
  
  const numPages = Math.ceil(total / limit);

  return (
    <>
      <Nav className="pagination">
        <Button onClick={() => setPage(page - 1)} disabled={page === 1}>
          &lt;
        </Button>
        {Array(numPages)
          .fill()
          .map((_, i) => (
            <Button
              key={i + 1}
              onClick={() => setPage(i + 1)}
              aria-current={page === i + 1 ? "page" : null}
            >
              {i + 1}
            </Button>
          ))}
        <Button onClick={() => setPage(page + 1)} disabled={page === numPages}>
          &gt;
        </Button>
      </Nav>
    </>
  );
}

const Nav = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin: 16px;
  padding-bottom : 40px;
`;

const Button = styled.button`
  border: none;
  border-radius: 8px;
  padding: 8px;
  margin: 0;
  background: black;
  color: white;
  font-size: 1rem;

  &:hover {
    background: #3bc9db;
    cursor: pointer;
    transform: translateY(-2px);
  }

  &[disabled] {
    background: grey; 
    cursor: revert;
    transform: revert;
  }

  &[aria-current] {
    background: grey;
    font-weight: bold;
    cursor: revert;
    transform: revert;
  }
`;

export default Pagination;
